import { render } from "./EventMatch.vue?vue&type=template&id=e1352344&scoped=true"
import script from "./EventMatch.vue?vue&type=script&lang=js"
export * from "./EventMatch.vue?vue&type=script&lang=js"

import "./EventMatch.vue?vue&type=style&index=0&id=e1352344&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1352344"]])

export default __exports__